import { z } from 'zod'

export const PROJECT_FILTERS_ORDER_DIRECTION = ['asc', 'desc'] as const
export const PROJECT_FILTERS_ORDER_BY = [
  'created_at',
  'updated_at',
  'name',
] as const

export const projectSearchFiltersSchema = z.object({
  tag_ids: z.array(z.string()).optional().describe('Tag IDs to filter by'),
  query: z.string().optional().describe('Query to filter by'),
  order_direction: z
    .enum(PROJECT_FILTERS_ORDER_DIRECTION)
    .optional()
    .describe('Direction by which to order the results'),
  order: z
    .enum(PROJECT_FILTERS_ORDER_BY)
    .optional()
    .describe('Field by which to order the results'),
})

export type ProjectSearchFilters = z.infer<typeof projectSearchFiltersSchema>
